import { transition } from '@helpers/animate';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
import ImageBannerStyles from '../ImageBanner/ImageBanner.styles';
import VideoBannerStyles from '../VideoBanner/VideoBanner.styles';
import { m } from 'framer-motion';
const Container = styled.div `
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;

  ${ImageBannerStyles.Image},
  ${VideoBannerStyles.Video} {
    position: absolute;
    top: 0;
    left: 0;
  }
`;
const ContentWrapper = styled(m.div) `
  position: relative;
  display: flex;
  flex-direction: column;
  place-items: center;
  gap: ${fluid(4, 8)};
  width: 100%;
  margin: auto 0;

  @media ${from(Device.MobileLarge)} {
    flex-direction: row;
    place-content: space-evenly;
    place-items: center;
  }
`;
const TextWrapper = styled.div `
  color: var(--fgColor);
  text-decoration: none;
  text-align: center;
  padding: 0 16px;

  &:is(a) {
    text-decoration: none;

    &:hover {
      text-underline-offset: 2px;
      text-decoration: underline;
    }
  }

  @media ${from(Device.Tablet)} {
    display: flex;
    gap: 4px;
  }
`;
const Text = styled.div `
  font-size: ${fluid(14, 18)};

  @media ${until(Device.Tablet)} {
    display: inline;

    &:after {
      content: ' ';
    }
  }
`;
const Countdown = styled.div `
  ${fonts.brandonGrotesque.medium}
  font-size: ${fluid(14, 18)};

  @media ${from(Device.MobileLarge)} {
    min-width: 140px;
  }

  @media ${until(Device.Tablet)} {
    display: inline;
  }
`;
const CtaWrapper = styled.div ``;
const CtaLink = styled.a `
  ${fonts.brandonGrotesque.bold}
  color: var(--fgColor);
  font-size: ${fluid(14, 18)};
  text-underline-offset: 2px;
  ${transition('text-underline-offset')}

  &:hover {
    text-underline-offset: 4px;
  }
`;
const CountdownBannerStyles = {
    Container,
    TextWrapper,
    Text,
    Countdown,
    CtaWrapper,
    CtaLink,
    ContentWrapper,
};
export default CountdownBannerStyles;
